import type { MaturityItemId } from '@cobliteam/hooks/src/useBasicValueMaturity/basicValueMaturityModel';

/**
 * Query string extra por etapa navegada — a página destino abre já com a criação em foco.
 *
 * Alertas cai na página de alarmes com a modal de criação aberta, como o Figma desenha. A rota
 * `ALERTS_TRIGGERS_CREATE`, que era o destino antigo, é uma página inteira e não a modal (AE-2520);
 * o `route` da etapa segue apontando para a página limpa, que é o destino do atalho "Meus alertas".
 */
export const NAVIGATE_SEARCH: Partial<Record<MaturityItemId, string>> = {
  checklists: '?create=true',
  alerts: '?create=true',
};

/**
 * Destino do "Configurar" de uma etapa sem criação assistida.
 *
 * `recommendationId` (só geofences) tem precedência: a sugestão pré-preenchida já abre o formulário,
 * então somar `?create=true` seria redundante — e as duas queries juntas gerariam uma URL inválida,
 * porque cada trecho aqui começa com "?".
 */
export const getStepNavigationTarget = (id: MaturityItemId, route: string, recommendationId?: string) =>
  recommendationId ? `${route}?recommendationId=${recommendationId}` : `${route}${NAVIGATE_SEARCH[id] ?? ''}`;
